import {DeliverySlot} from '../types/store/basket'

export const useVipRestrictions = () => {
  const isVipDeliverySlot = (day: DeliverySlot) => {
    return day.slots.filter((slot) => slot.vipSlot).length > 0
  }

  return {
    isVipDeliverySlot,
  }
}
